import React from 'react';

import RightClickMenu from 'components/RightClickMenu/RightClickMenu';

import { MainWrapper, MaiColumnnWrapper } from './styles';

const optionsMock = [
  {
    icon: 'cube',
    label: 'Make!',
    onClick: () => {},
  },
  {
    icon: 'download',
    label: 'Download as...',
    onClick: () => {},
    options: [
      {
        loading: true,
        loadLabel: 'Processing...',
        icon: 'download',
        iconLast: true,
        label: '.step File',
        extraLabel: '3.3 MB',
        onClick: () => {},
      },
      {
        loading: false,
        loadLabel: 'Processing...',
        icon: 'download',
        iconLast: true,
        label: '.stil File',
        extraLabel: '5.7 MB',
        onClick: () => {},
      },
    ],
  },
];

const TestPage = () => {
  return (
    <MainWrapper>
      <RightClickMenu isDark={false} options={optionsMock} />
      <MaiColumnnWrapper>{}</MaiColumnnWrapper>
    </MainWrapper>
  );
};

export default TestPage;
